import { useCallback, useMemo } from 'react';

const useFlightType = ({ dispatch, value, initValue }) => {
  const onChange = useCallback(
    (selectedType) => {
      dispatch({ type: 'FLIGHT_TYPE_CHANGE', payload: selectedType.value });
    },
    [dispatch]
  );

  return useMemo(() => ({ value, defaultValue: value, onChange, isChanged: initValue !== value }), [
    value,
    onChange,
    initValue
  ]);
};

export default useFlightType;
